<section>
  <div
    class="mt-9 text-center text-green-600 text-xl font-semibold tracking-wide"
  >
    <img
      [src]="imageUrl"
      alt="Success"
      style="width: 120px; margin-bottom: 16px"
    />
    <h1>Your assignment has been {{ actiontaken }} successfully!</h1>
    <div class="mt-6 flex justify-center p-2">
      <table
        class="min-w-[500px] border border-gray-300 text-left bg-white rounded-lg"
      >
        <tr class="bg-gray-100">
          <th class="p-3 border">Subject</th>
          <td class="p-3 border">{{ assignment?.subject }}</td>
        </tr>
        <tr>
          <th class="p-3 border">Assignment Title</th>
          <td class="p-3 border">{{ assignment?.assignmentTitle }}</td>
        </tr>
        <tr>
          <th class="p-3 border">Class</th>
          <td class="p-3 border">{{ assignment?.class }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center gap-3">
      <button
        mat-flat-button
        color="primary"
        class="mt-6 px-6 py-2 rounded-lg"
        (click)="goBack()"
      >
        <i class="fa-solid fa-arrow-left me-2"></i>
        Back to assignments
      </button>
      <button
        mat-flat-button
        color="primary"
        class="mt-6 px-6 py-2 rounded-lg"
        (click)="viewSubmissionDetails()"
      >
        <i class="fa-solid fa-eye me-2"></i>
        View Submisstion Details
      </button>
    </div>
  </div>
</section>
